



















import {Component, Prop, Vue} from "vue-property-decorator";
import HelpMenuItemR from "@/components/for-help-page/HelpMenuItem.vue";
@Component({
  components: {HelpMenuItemR}
})
class HelpMenuItem extends Vue {
  @Prop({ default: "" }) readonly title!: String;
  @Prop({ default: "" }) readonly routeName!: String;
  @Prop({ default: 0 }) readonly level!: number;
}
export default HelpMenuItem;
